import { fileFormToUpdate } from '@/_containers';
import { agreementStatusToStr } from '@/_schemas/agreements/agreement-status-schema';
import { pipelineToStr } from '@/_schemas/agreements/agreements-pipeline-schemas';
import { subsidiesTypeToStr } from '@/_schemas/agreements/subsidies-type-schemas';
import { booleanFormToUpdateConverter, nullableStringToNullableIntConverter } from '@/_schemas/generic';

import { contractingPartyToStr } from '../components/contracting-party/schema';
import type { AgreementFormSchema, AgreementUpdateSchema } from '../schemas';

export function agreementFormToUpdate({
  status,
  pipeline,
  client,
  primary_domains,
  account_manager,
  agreement_deliverables,
  agreement_contact,
  billing_contact,
  project_contact,
  emergency_contact,
  billing_email_contacts,
  expiry_date,
  agreement_date,
  billing_term,
  terms_condition_template,
  brand,
  partner,
  harvest,
  agreement_draft,
  fully_executed_agreement,
  execution_date,
  implementation_start_date,
  go_live_date,
  monthly_recurring_start_date,
  monthly_recurring_stop_date,
  agreement_signer,
  wholesale_price_enabled,
  addresses,
  parent_id,
  contracting_party,
  activate_subsidy_billing,
  subsidies,
  orphan_invoicing,
  ...rest
}: AgreementFormSchema): AgreementUpdateSchema {
  return {
    ...rest,
    parent_id,
    status: agreementStatusToStr(status),
    pipeline: pipelineToStr(pipeline, !!parent_id),
    client_id: client?.id ?? null,
    account_manager: account_manager?.map((item, i) => ({ id: item.id, sort_order: i + 1 })) ?? [],

    brand_id: brand?.id ?? null,
    partner_id: partner?.id ?? null,

    primary_domains: primary_domains?.id ? [primary_domains?.id ?? -1] : null,
    agreement_contact: agreement_contact?.id ? [agreement_contact?.id] : [],
    billing_contact: billing_contact?.id ? [billing_contact?.id] : [],
    project_contact: project_contact?.id ? [project_contact?.id] : [],
    agreement_date,
    expiry_date,
    emergency_contact: emergency_contact?.map((ac) => ac.id ?? -1) ?? [],
    billing_email_contacts: billing_email_contacts?.map((ac) => ac.id ?? -1) ?? [],
    agreement_deliverables: agreement_deliverables.map(({ id }) => id),
    billing_term_id: billing_term?.id ?? null,
    terms_condition_template_id: terms_condition_template?.id ?? null,
    agreement_signer_id: agreement_signer?.id ?? null,
    harvest: nullableStringToNullableIntConverter(harvest),

    agreement_draft: fileFormToUpdate(agreement_draft),
    fully_executed_agreement: fileFormToUpdate(fully_executed_agreement),

    execution_date: dateFormToUpdate(execution_date),
    implementation_start_date: dateFormToUpdate(implementation_start_date),
    go_live_date: dateFormToUpdate(go_live_date),
    monthly_recurring_start_date: dateFormToUpdate(monthly_recurring_start_date),
    monthly_recurring_stop_date: dateFormToUpdate(monthly_recurring_stop_date),

    agreement_installments: [], // TODO: Fix it
    wholesale_price_enabled: booleanFormToUpdateConverter(wholesale_price_enabled),
    addresses: addresses?.map((item) => item.id) ?? [],

    activate_subsidy_billing: booleanFormToUpdateConverter(Boolean(activate_subsidy_billing)),
    contracting_party: contractingPartyToStr(contracting_party),

    subsidies:
      subsidies?.map((s) => ({
        id: s.id ?? -1,
        agreement_id: rest.id ?? -1,
        client_id: s.client?.id ?? -1,
        addresses: s.addresses?.map((a) => a.id ?? -1) ?? [],
        primary_contact: s?.primary_contact?.map((p) => p?.id ?? -1) ?? [],
        subsidy_type: subsidiesTypeToStr(s.subsidy_type),
        subsidy_deliverables: [],
      })) ?? null,

    orphan_invoicing: booleanFormToUpdateConverter(Boolean(orphan_invoicing)),
  };
}

function dateFormToUpdate(data: string | undefined | null): string | null {
  return data ? data : null;
}
